<div class="confirmation-modal" [class.redesign]="isRedesign">
  @if (title) {
    <div class="modal-header">
      <div class="modal-title page-title eyebrow pull-left inline">
        <h4>{{title}}</h4>
      </div>
      @if (showCloseButton) {
        <button type="button" class="close pull-right" (click)="hideConfirmationModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  <div class="modal-body">
    <p [innerHTML]="body | keepHtml"></p>
  </div>
  <div class="modal-footer">
    <div class="text-end">
      @if (isDangerous) {
        <span class="me-2">
          {{dangerousText}}
        </span>
      }
      <button type="button" class="me-2 btn" [ngClass]="{'btn-danger': isDangerous, 'btn-primary': !isDangerous}" (click)="onConfirm()">
        {{okButtonText}}
      </button>
      @if (showCancel) {
        <button type="button" class="btn btn-primary-outline" (click)="onCancel()">
          {{cancelButtonText}}
        </button>
      }
    </div>
  </div>
</div>
